<template>
  <div
    class="bg-surface-50 dark:bg-surface-800 rounded-lg p-3"
    :data-test-id="`error-reference-${testIdSuffix}`"
  >
    <h4 class="text-sm font-medium text-surface-500 dark:text-surface-400 mb-1">
      {{ reference.label }}
    </h4>
    <div class="flex items-center gap-2">
      <code
        class="flex-1 text-sm font-mono text-primary-600 dark:text-primary-400 break-all"
        :data-test-id="`error-reference-${testIdSuffix}-value`"
        >{{ reference.value }}</code
      >
      <Button
        :icon="copied ? 'pi pi-check' : 'pi pi-copy'"
        :label="copied ? 'Copied' : 'Copy'"
        variant="text"
        size="small"
        severity="secondary"
        :aria-label="`Copy ${reference.label}`"
        :data-test-id="`error-reference-${testIdSuffix}-copy`"
        @click="copy(reference.value)"
      />
    </div>
    <p
      v-if="reference.hint"
      class="text-xs text-surface-500 dark:text-surface-400 mt-2"
    >
      {{ reference.hint }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import Button from 'primevue/button'
import { useCopyToClipboard } from '@/composables/useCopyToClipboard'
import type { ErrorReference } from '@/stores/errorDetailsStore'

const props = defineProps<{
  reference: ErrorReference
}>()

// "Avalara correlation ID" -> "avalara-correlation-id", so a test can find one reference by its label.
const testIdSuffix = computed(() =>
  props.reference.label.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
)

const { copy, copied } = useCopyToClipboard()
</script>
